import WorkForceFreelanceCompanies from "../../views/WorkForceFreelanceCompanies";

const WorkForceFreelanceCompaniesPage = () => {
  return <WorkForceFreelanceCompanies />;
};

export default WorkForceFreelanceCompaniesPage;
